import { useQuery } from '@tanstack/react-query';
import { useClientStore } from '@/client/stores/client';
import { withErrorHandling } from '@/client/utils/errors';
import { DEFAULT_GC_TIME } from '@/client/constants';
import { AppVersionConfig, AppVersionEnvelope } from '@/client/types/app-version';

export const appVersionKeys = {
  all: ['app-version'] as const,
  config: () => [...appVersionKeys.all, 'config'] as const,
};

const useAppVersionConfigFn = () => {
  const request = useClientStore((s) => s.request);
  return withErrorHandling(async (): Promise<AppVersionConfig> => {
    const res = await request<AppVersionEnvelope<AppVersionConfig>>('/api/admin/app-version');
    return res.data;
  }, 'An unexpected error occurred while fetching the app version config');
};

export const useAppVersionConfigQuery = () => {
  const queryFn = useAppVersionConfigFn();
  return useQuery({
    queryKey: appVersionKeys.config(),
    queryFn,
    // Another admin may flip maintenance; keep the form close to what phones see.
    staleTime: 1000 * 30,
    gcTime: DEFAULT_GC_TIME,
    retry: (failureCount, error: any) => {
      if (error?.status === 401 || error?.status === 403) return false;
      return failureCount < 2;
    },
  });
};
